// extracted by mini-css-extract-plugin
export var dayLabel = "_kk-0";
export var pickerDisabled = "_kk-1";